
import React from 'react';
import { PlusIcon, SettingsIcon, ClockIcon, MenuIcon, DownloadIcon } from './icons';

interface HeaderProps {
  title: string;
  onAddPrayer: () => void;
  onStartPrayerTime: () => void;
  onShowSettings: () => void;
  onToggleSidebar: () => void;
  showInstallPrompt: boolean;
  onInstall: () => void;
}

const Header: React.FC<HeaderProps> = ({ title, onAddPrayer, onStartPrayerTime, onShowSettings, onToggleSidebar, showInstallPrompt, onInstall }) => {
  return (
    <header className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm border-b border-gray-200 dark:border-gray-700 px-4 sm:px-6 lg:px-8 py-4 sticky top-0 z-10 flex-shrink-0">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
            <button onClick={onToggleSidebar} className="p-1 -ml-2 text-gray-500 dark:text-gray-300 hover:text-gray-800 dark:hover:text-white md:hidden">
                <MenuIcon className="w-6 h-6" />
            </button>
            <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 truncate pr-4">{title}</h2>
        </div>
        <div className="flex items-center gap-2 sm:gap-3">
            <button
                onClick={onStartPrayerTime}
                className="flex items-center gap-2 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-200 font-semibold py-2 px-4 rounded-full border border-gray-300 dark:border-gray-600 shadow-sm hover:bg-gray-50 dark:hover:bg-gray-600 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                title="Start Prayer Time"
            >
                <ClockIcon className="w-5 h-5 text-gray-500 dark:text-gray-400" />
                <span className="hidden sm:inline">Prayer Time</span>
            </button>
            {showInstallPrompt && (
                 <button
                    onClick={onInstall}
                    className="flex items-center gap-2 bg-green-500 text-white font-bold py-2 px-4 rounded-full shadow-lg hover:bg-green-600 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-green-300 dark:focus:ring-green-800 transform hover:scale-105"
                 >
                    <DownloadIcon className="w-5 h-5" />
                    <span className="hidden sm:inline">Install</span>
                </button>
            )}
            <button
                onClick={onAddPrayer}
                className="flex items-center gap-2 bg-indigo-600 text-white font-bold py-2 px-4 rounded-full shadow-lg hover:bg-indigo-700 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-indigo-300 dark:focus:ring-indigo-800 transform hover:scale-105"
            >
                <PlusIcon className="w-5 h-5" />
                <span className="hidden sm:inline">Add Prayer</span>
            </button>
            <button
                onClick={onShowSettings}
                className="p-2 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-800 dark:hover:text-white transition-colors"
                aria-label="Settings"
            >
                <SettingsIcon className="w-6 h-6" />
            </button>
        </div>
      </div>
    </header>
  );
};

export default Header;